import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { EsriMapComponent } from "./esri-map/esri-map.component";
import { AuthGuard } from "../shared/guards/auth-guard/auth.guard";
const routes = [
    {
        path: "",
        component: EsriMapComponent,
        canActivate: [AuthGuard]
    }
];
let MapRoutingModule = class MapRoutingModule {
};
MapRoutingModule = __decorate([
    NgModule({
        imports: [RouterModule.forChild(routes)],
        exports: [RouterModule]
    })
], MapRoutingModule);
export { MapRoutingModule };
